<!-- 发起弹窗 -->
<template>
  <div>
    <el-dialog
      :title="typeText"
      :visible="isShowAddRechargeWithdrawDialog"
      width="30%"
      :close-on-click-modal="false"
      @close="handleDialog"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item :label="$t('text.merchant')" prop="appId">
          <el-select
            v-model="form.appId"
            filterable
            :placeholder="$t('message.chooseOne')"
            popper-class="eloption"
          >
            <el-option
              v-for="merchant in merchantList"
              :label="merchant.value + '-' + merchant.name"
              :key="merchant.value"
              :value="merchant.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('text.amount')" prop="amount">
          <el-input
            size="small"
            type="text"
            v-model="form.amount"
            :placeholder="$t('message.inputAmount',{type:typeText})"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('text.remark')" prop="remark">
          <el-input
            size="small"
            type="textarea"
            v-model="form.remark"
            :placeholder="$t('message.inputRemark')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">{{ $t('text.cancel') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('text.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: "00" // 00 = Recharge | 01 = Withdraw
    },
    isShowAddRechargeWithdrawDialog: {
      type: Boolean,
      default: false
    },
    merchantList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      form: {
        orderId: "0",
        appId: "",
        amount: "",
        remark: "",
        paymentAccount: "0",
        collectAccount: "0"
      },
      rules: {
        appId: [{ required: true, message: this.$t('message.appIdRequiredError'), trigger: "blur" }],
        amount: [{ required: true, message: this.$t('message.inputAmount'), trigger: "blur" }],
        remark: [{ required: true, message: this.$t('message.inputRemark'), trigger: "blur" }]
      }
    };
  },
  computed: {
    typeText() {
      if (this.type === "00") {
        return this.$t('text.credit');
      } else if (this.type === "01") {
        return this.$t('text.debit');
      } else {
        return "";
      }
    }
  },
  methods: {
    handleDialog() {
      this.$refs["form"].resetFields();
      this.form = {
        orderId: "0",
        appId: "",
        amount: "",
        remark: "",
        paymentAccount: "0",
        collectAccount: "0"
      };
      this.$emit("update:isShowAddRechargeWithdrawDialog", false);
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const params = {
            ...this.form,
            type: this.type
          };
          this.$axios
            .post("/depositWithdraw/addDepositWithdrawAdmin", params)
            .then((res) => {
              if (res.code === 200) {
                this.$notify({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                  type: "success"
                });
                this.$emit("update:isShowAddRechargeWithdrawDialog", false);
                this.$bus.$emit("refresh"); //通知刷新
              } else {
                this.$notify.error({
                  title: this.$t('text.prompt'),
                  message: res.msg
                });
              }
            });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
</style>
